import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProjectRole } from '@zerops/models/project';

@Component({
  selector: 'zui-project-access-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './project-access-chip.component.html',
  styleUrl: './project-access-chip.component.scss'
})
export class ProjectAccessChipComponent {
  // # Inputs
  projectId = input.required<string>();
  roleCode = input<ProjectRole | null>(null);
  disableLinks = input<boolean>(false);

  // # Computed
  isFullAccess = computed(() => this.roleCode() === 'ADMIN' || this.roleCode() === 'OWNER');

  roleLabel = computed(() =>
    this.isFullAccess() ? 'Full access' : 'Read access'
  );

  settingsLink = computed(() =>
    this.disableLinks() ? null : [ '/', 'project', this.projectId(), 'settings' ]
  );
}
